module.exports = __webpack_public_path__ + "static/media/Online-Payment-Unpaid.e0d12a16.png";